.iconAnimation {
    transition: transform 0.1s ease;
}
